"use strict";

/*==============================================================================*
*TRESTLE™ W003
*FOOD DATA
*Version 1.0
*
*Contains all Food Cheat Codes used by W003.
*No rendering logic.
*No DOM manipulation.
*==============================================================================*/

const TRESTLE_FOOD_DATA={

    balanced_life:{

        not_sure:{

            image:"https://cdn.shopify.com/s/files/1/0588/5250/7777/files/healthy_meal.webp?v=1786090026",

            title:"Food Cheat Codes",

            intro:"Practical food and drink suggestions to support a balanced workday. These are general wellness recommendations and are not a substitute for personalised medical or dietary advice.",

            morning:"Start your day with a protein-rich breakfast such as eggs or sprouts, whole grains, nuts, and unsweetened tea or coffee. Stay well hydrated.",

            midday:"Choose a balanced lunch with vegetables, whole grains (millets, brown rice or roti), lean protein such as dal, paneer, fish or chicken, and curd. Avoid sugary drinks.",

            afternoon:"Choose a healthy snack such as fruit, roasted chana, nuts, seeds or yogurt. Prefer water, buttermilk or green tea over sweetened beverages.",

            beforeLeaving:"Before leaving work, have a light protein-rich snack such as sprouts, boiled eggs, roasted makhana or a handful of nuts with water to maintain steady energy and help reduce overeating later.",

            advisory:"General educational guidance only. Individual nutritional needs vary depending on health status, medications and medical history. Consult your healthcare professional or registered dietitian for personalised advice."

        },

        prediabetes:{

            image:"https://cdn.shopify.com/s/files/1/0588/5250/7777/files/food_prediabetics.webp?v=1786083641",

            intro:"Practical food and drink suggestions to support a balanced workday while helping maintain healthy blood sugar levels.",

            morning:"Protein-rich breakfast with whole grains, eggs or sprouts, unsweetened yogurt, nuts, and unsweetened tea or coffee.",

            midday:"Balanced lunch with whole grains (millets or brown rice), lean protein, plenty of vegetables, salad, and water or buttermilk.",

            afternoon:"Healthy snack such as roasted chana, nuts, seeds, fruit paired with nuts, or Greek yogurt. Avoid sugary snacks and soft drinks.",

            beforeLeaving:"Light protein-rich snack such as sprouts, boiled eggs, paneer, hummus with vegetables, or a handful of nuts. Stay hydrated with water or herbal tea.",

            advisory:"Educational guidance only. If you have prediabetes or another medical condition, seek personalised advice from your healthcare professional or registered dietitian."

        },

        type_1_diabetes:{

            image:"https://cdn.shopify.com/s/files/1/0588/5250/7777/files/food_diabetics.webp?v=1786083640",

            intro:"Balanced food choices can help support energy levels throughout the workday. Match carbohydrate intake with your insulin plan and monitor blood glucose as advised.",

            morning:"Protein-rich breakfast with whole grains, eggs or paneer, unsweetened yogurt, nuts, and a sugar-free beverage.",

            midday:"Balanced lunch with lean protein, high-fiber vegetables, controlled portions of whole grains, and water or unsweetened buttermilk.",

            afternoon:"Healthy snack such as nuts, roasted chana, Greek yogurt, or a small fruit if needed. Stay hydrated with water or unsweetened tea.",

            beforeLeaving:"Light protein-and-fiber snack such as sprouts, boiled eggs, cheese, or nuts if there is a long gap before dinner. Carry a fast-acting glucose source for emergencies.",

            advisory:"Educational guidance only. Match meals and snacks with insulin dosing and your healthcare team's advice." 

        },

        type_2_diabetes:{

            image:"https://cdn.shopify.com/s/files/1/0588/5250/7777/files/food_diabetics.webp?v=1786083640",

            intro:"Choose balanced meals with adequate protein and fiber to help support steady energy and blood glucose throughout the workday.",

            morning:"High-protein breakfast with whole grains, eggs or paneer, unsweetened yogurt, and unsweetened tea or coffee.",

            midday:"Balanced lunch with vegetables, dal or beans, lean protein, whole grains (roti or brown rice), and salad. Avoid sugary drinks.",

            afternoon:"Healthy snack such as nuts, seeds, roasted chana, sprouts, or a low-GI fruit. Drink water or unsweetened green or herbal tea.",

            beforeLeaving:"Light protein-rich snack such as buttermilk, boiled eggs, tofu, roasted nuts, or Greek yogurt to help maintain steady energy until dinner.",

            advisory:"Educational guidance only. Individual dietary needs may vary depending on medications and blood glucose control."

        },

        gestational_diabetes:{

            image:"https://cdn.shopify.com/s/files/1/0588/5250/7777/files/food_gestational_diabetics.webp?v=1786083640",

            intro:"Choose balanced meals and regular snacks to help support healthy blood glucose during pregnancy. These recommendations are educational and should complement the guidance provided by your obstetrician and dietitian.",

            morning:"Begin the day with a protein-rich breakfast such as eggs, paneer, sprouts or unsweetened yogurt, together with whole grains and water or unsweetened milk.",

            midday:"Choose a balanced lunch with vegetables, dal or lean protein, whole grains in controlled portions, curd or buttermilk, and plenty of water.",

            afternoon:"Have a nutritious snack such as nuts, seeds, roasted chana, sprouts or Greek yogurt. Avoid sugary beverages and highly processed snacks.",

            beforeLeaving:"Before leaving work, choose a light protein-rich snack such as paneer, boiled eggs, sprouts, roasted makhana or a handful of nuts if there is a long gap before dinner.",

            advisory:"Educational guidance only. If you have gestational diabetes, follow the meal plan and glucose-monitoring advice provided by your obstetrician, diabetologist or registered dietitian."

        },

        previous_gestational_diabetes:{

            image:"https://cdn.shopify.com/s/files/1/0588/5250/7777/files/food_previous_gestational_diabetics.webp?v=1786083640",

            intro:"Healthy eating after pregnancy can help support long-term metabolic health. Continue choosing balanced meals and maintain regular eating habits.",

            morning:"Start the day with a balanced breakfast including protein, whole grains and healthy fats. Choose unsweetened beverages and drink adequate water.",

            midday:"Eat a balanced lunch with vegetables, lean protein, whole grains and curd or buttermilk. Limit refined carbohydrates and sugary drinks.",

            afternoon:"Select healthy snacks such as fruit paired with nuts, roasted chana, seeds or yogurt instead of processed snacks.",

            beforeLeaving:"Choose a light protein-rich snack such as sprouts, paneer, roasted makhana or a handful of mixed nuts to help maintain energy until dinner.",

            advisory:"Educational guidance only. Women with a history of gestational diabetes have an increased future risk of Type 2 diabetes. Regular health check-ups and personalised dietary advice are recommended."

        }

    },
    more_calmness:{

        not_sure:{

        image:"https://cdn.shopify.com/s/files/1/0588/5250/7777/files/healthy_meal.webp?v=1786090026",

        intro:"Choose calming, nourishing foods and stay hydrated throughout your workday. Small, balanced meals and mindful eating may help support a greater sense of calm and steady energy.",

        morning:"Begin the day with a protein-rich breakfast such as oats with nuts and seeds, eggs, sprouts or unsweetened yogurt. Pair with herbal tea or unsweetened tea or coffee.",

        midday:"Choose a balanced lunch with vegetables, whole grains, lean protein and curd or buttermilk. Avoid skipping meals or relying on processed foods.",

        afternoon:"Choose calming snacks such as roasted chana, nuts, seeds, fresh fruit with nuts or yogurt. Stay hydrated with water or herbal tea.",

        beforeLeaving:"Before leaving work, enjoy a light snack such as sprouts, roasted makhana, paneer cubes or a handful of mixed nuts if dinner will be delayed.",

        advisory:"Educational guidance only. Food supports overall wellbeing but does not replace professional medical or mental health care."

        },

        prediabetes:{

        image:"https://cdn.shopify.com/s/files/1/0588/5250/7777/files/food_prediabetics.webp?v=1786083641",

        intro:"Balanced meals with protein, fibre and healthy fats may help support stable energy and blood glucose while promoting a calmer workday.",

        morning:"Choose eggs, sprouts or unsweetened yogurt with whole grains and nuts. Avoid sugary breakfast foods.",

        midday:"Enjoy vegetables, lean protein, dal or beans and whole grains with water or buttermilk.",

        afternoon:"Snack on roasted chana, seeds, nuts or Greek yogurt instead of refined snacks or sweet beverages.",

        beforeLeaving:"A protein-rich snack such as paneer, sprouts or mixed nuts may help bridge the gap until dinner.",

        advisory:"Educational guidance only. If you have prediabetes, follow personalised dietary advice from your healthcare professional."

        },

        type_1_diabetes:{

            image:"https://cdn.shopify.com/s/files/1/0588/5250/7777/files/food_diabetics.webp?v=1786083640",

            intro:"Balanced nutrition together with appropriate insulin management can help maintain steady energy and reduce unnecessary glucose fluctuations during the workday.",

            morning:"Eat a balanced breakfast containing protein, whole grains and healthy fats while following your prescribed insulin plan.",

            midday:"Choose lean protein, vegetables and controlled portions of whole grains. Stay hydrated with water or unsweetened beverages.",

            afternoon:"Snack on nuts, roasted chana or yogurt if required. Always carry a fast-acting glucose source for hypoglycaemia.",

            beforeLeaving:"Choose a light protein-rich snack if there will be a long interval before dinner.",

            advisory:"Educational guidance only. Match meals and snacks with your insulin regimen and healthcare team's advice."

        },
        type_2_diabetes:{

        image:"https://cdn.shopify.com/s/files/1/0588/5250/7777/files/food_diabetics.webp?v=1786083640",

        intro:"Choose balanced meals that help maintain steady energy while supporting healthy blood glucose levels. Regular meal timing and mindful food choices can contribute to a calmer workday.",

        morning:"Begin with a protein-rich breakfast such as eggs, paneer, sprouts or unsweetened yogurt together with whole grains and unsweetened tea or coffee.",

        midday:"Choose vegetables, dal or lean protein, whole grains in controlled portions and curd or buttermilk. Drink plenty of water.",

        afternoon:"Snack on roasted chana, nuts, seeds or Greek yogurt instead of sugary or highly processed snacks.",

        beforeLeaving:"If dinner will be delayed, choose a light protein-rich snack such as sprouts, paneer, roasted makhana or mixed nuts.",

        advisory:"Educational guidance only. Follow the meal plan and medication advice provided by your healthcare professional."

        },

        gestational_diabetes:{

        image:"https://cdn.shopify.com/s/files/1/0588/5250/7777/files/food_gestational_diabetics.webp?v=1786083640",

        intro:"Regular, balanced meals may help support healthy blood glucose levels during pregnancy while maintaining steady energy throughout the workday.",

        morning:"Choose a protein-rich breakfast with eggs, paneer, sprouts or unsweetened yogurt together with whole grains and water or milk.",

        midday:"Eat vegetables, lean protein or dal, controlled portions of whole grains and curd or buttermilk. Avoid sugary drinks.",

        afternoon:"Healthy snacks such as roasted chana, sprouts, nuts, seeds or Greek yogurt may help bridge the gap between meals.",

        beforeLeaving:"Choose a light protein-rich snack if there will be a long gap before dinner and continue drinking water regularly.",

        advisory:"Educational guidance only. Follow the dietary advice provided by your obstetrician, diabetologist or registered dietitian."

        },

        previous_gestational_diabetes:{

        image:"https://cdn.shopify.com/s/files/1/0588/5250/7777/files/food_previous_gestational_diabetics.webp?v=1786083640",

        intro:"Healthy eating after pregnancy can support long-term metabolic wellbeing while helping reduce future diabetes risk.",

        morning:"Start with a balanced breakfast containing protein, whole grains and healthy fats together with an unsweetened beverage.",

        midday:"Enjoy vegetables, lean protein, whole grains and curd or buttermilk while limiting refined carbohydrates.",

        afternoon:"Choose fruit with nuts, roasted chana, seeds or yogurt instead of processed snacks or sweet beverages.",

        beforeLeaving:"A light snack such as paneer, sprouts, roasted makhana or mixed nuts can help maintain steady energy until dinner.",

        advisory:"Educational guidance only. Women with a history of gestational diabetes should continue regular health check-ups and healthy lifestyle practices."

        }

    },

    better_sleep:{

    not_sure:{

        image:"https://cdn.shopify.com/s/files/1/0588/5250/7777/files/healthy_meal.webp?v=1786090026",

        intro:"Choose balanced foods and drinks that support steady energy through the workday while avoiding habits that may interfere with restful sleep later.",

        morning:"Start with a protein-rich breakfast such as eggs, sprouts, paneer or unsweetened yogurt with whole grains. Tea or coffee is fine in moderation.",

        midday:"Choose a balanced lunch with vegetables, whole grains, lean protein such as dal, paneer, fish or chicken, and curd. Avoid very heavy meals that may leave you sluggish.",

        afternoon:"Choose a light snack such as fruit with nuts, roasted chana, seeds or yogurt. Reduce caffeine later in the workday, especially if it affects your sleep.",

        beforeLeaving:"If hungry before leaving work, choose a light snack such as sprouts, roasted makhana, nuts or yogurt. Avoid relying on sugary snacks or caffeinated drinks for an evening energy boost.",

        advisory:"General educational guidance only. Persistent sleep difficulties may have many causes. Consult a qualified healthcare professional if sleep problems continue."

    },

    prediabetes:{

        image:"https://cdn.shopify.com/s/files/1/0588/5250/7777/files/food_prediabetics.webp?v=1786083641",

        intro:"Balanced meals and steady blood glucose through the workday may support energy and help avoid eating patterns that can interfere with restful sleep.",

        morning:"Choose protein such as eggs, sprouts or unsweetened yogurt with whole grains, nuts or seeds. Avoid sugary breakfast foods and sweetened drinks.",

        midday:"Choose vegetables, lean protein, dal or beans and a controlled portion of whole grains. Water or unsweetened buttermilk can accompany the meal.",

        afternoon:"Choose roasted chana, nuts, seeds or unsweetened yogurt instead of refined snacks. Limit caffeine later in the day if it affects your sleep.",

        beforeLeaving:"If dinner is some time away, choose a small protein-rich snack such as paneer, sprouts, roasted makhana or nuts rather than sugary foods.",

        advisory:"Educational guidance only. If you have prediabetes, follow personalised dietary guidance from your healthcare professional or registered dietitian."

    },

        type_1_diabetes:{

        image:"https://cdn.shopify.com/s/files/1/0588/5250/7777/files/food_diabetics.webp?v=1786083640",

        intro:"Regular meals, appropriate carbohydrate planning and your prescribed insulin routine can help support stable glucose and energy through the workday.",

        morning:"Choose a balanced breakfast with protein, whole grains and healthy fats while following your prescribed carbohydrate and insulin plan.",

        midday:"Choose vegetables, lean protein and an appropriate portion of whole grains according to your meal plan. Stay hydrated with water or unsweetened beverages.",

        afternoon:"Choose a planned snack if needed and limit caffeine later in the day if it affects your sleep. Always keep your recommended fast-acting glucose source available for hypoglycaemia.",

        beforeLeaving:"If there will be a long interval before dinner, choose an appropriate snack consistent with your carbohydrate and insulin plan.",

        advisory:"Educational guidance only. Meal timing, carbohydrate intake and insulin requirements are individual. Follow the plan provided by your diabetes healthcare team."

        },

        type_2_diabetes:{

        image:"https://cdn.shopify.com/s/files/1/0588/5250/7777/files/food_diabetics.webp?v=1786083640",

        intro:"Balanced meals, regular eating patterns and reduced caffeine later in the day may help support steady blood glucose and better sleep quality.",

        morning:"Choose a protein-rich breakfast such as eggs, paneer, sprouts or unsweetened yogurt with whole grains and an unsweetened beverage.",

        midday:"Choose vegetables, dal or lean protein, whole grains in controlled portions and curd or buttermilk. Avoid sugary drinks and very heavy meals.",

        afternoon:"Choose nuts, roasted chana, seeds or unsweetened yogurt for a light snack. Limit caffeine later in the day if it affects your sleep.",

        beforeLeaving:"If hungry before leaving work, choose a light protein-rich snack such as sprouts, paneer, boiled eggs or roasted makhana rather than sugary snacks.",

        advisory:"Educational guidance only. Individual dietary needs may vary depending on medications, blood glucose control and other health conditions."

        },

        gestational_diabetes:{

        image:"https://cdn.shopify.com/s/files/1/0588/5250/7777/files/food_gestational_diabetics.webp?v=1786083640",

        intro:"Balanced meals and planned snacks can help support healthy blood glucose during pregnancy while avoiding eating patterns that may interfere with restful sleep.",

        morning:"Choose a protein-rich breakfast such as eggs, paneer, sprouts or unsweetened yogurt with whole grains and water or milk, according to your prescribed meal plan.",

        midday:"Choose vegetables, dal or lean protein, controlled portions of whole grains and curd or buttermilk. Avoid sugary beverages.",

        afternoon:"Choose a light snack such as nuts, seeds, roasted chana, sprouts or unsweetened yogurt. Limit caffeine if advised by your healthcare professional.",

        beforeLeaving:"If there will be a long gap before dinner, choose a light protein-rich snack and continue drinking water regularly.",

        advisory:"Educational guidance only. If you have gestational diabetes, follow the dietary and glucose-monitoring advice provided by your obstetrician, diabetologist or registered dietitian."

        },

        previous_gestational_diabetes:{

        image:"https://cdn.shopify.com/s/files/1/0588/5250/7777/files/food_previous_gestational_diabetics.webp?v=1786083640",

        intro:"Balanced eating habits and sensible evening choices can support long-term metabolic health while helping establish routines that may support better sleep.",

        morning:"Start with a balanced breakfast containing protein, whole grains, nuts or seeds and an unsweetened beverage.",

        midday:"Choose vegetables, lean protein, whole grains and curd or buttermilk. Limit refined carbohydrates and sugary drinks.",

        afternoon:"Choose fruit paired with nuts, roasted chana, seeds or yogurt instead of processed snacks. Reduce caffeine later in the day if it affects your sleep.",

        beforeLeaving:"Choose a light snack such as sprouts, paneer, roasted makhana or mixed nuts if dinner will be delayed.",

        advisory:"Educational guidance only. A history of gestational diabetes is associated with a higher future risk of Type 2 diabetes, so regular health check-ups and healthy lifestyle habits remain important."

        },

    },

    more_energy:{

    not_sure:{

        image:"https://cdn.shopify.com/s/files/1/0588/5250/7777/files/healthy_meal.webp?v=1786090026",

        intro:"Choose balanced meals, regular snacks and adequate hydration to help maintain steady energy through the workday without relying heavily on sugar or caffeine.",

        morning:"Start with a protein-rich breakfast such as eggs, paneer, sprouts or unsweetened yogurt with whole grains, nuts or seeds. Choose water, tea or coffee without excess sugar.",

        midday:"Choose a balanced lunch with vegetables, whole grains, dal or another lean protein and curd or buttermilk. Avoid very heavy meals that may leave you sluggish.",

        afternoon:"Choose an energising snack such as fruit with nuts, roasted chana, seeds or yogurt. Drink water regularly instead of relying on sugary or highly caffeinated drinks.",

        beforeLeaving:"If dinner is still some time away, choose a light snack such as sprouts, paneer, roasted makhana or mixed nuts to help maintain energy.",

        advisory:"General educational guidance only. Persistent or unexplained tiredness can have many causes and should be discussed with a qualified healthcare professional."

    },

        prediabetes:{

            image:"https://cdn.shopify.com/s/files/1/0588/5250/7777/files/food_prediabetics.webp?v=1786083641",

            intro:"Balanced meals with protein, fibre and healthy fats can help support steadier energy while avoiding sharp changes in blood glucose.",

            morning:"Choose eggs, sprouts, paneer or unsweetened yogurt with whole grains, nuts or seeds. Avoid sugary breakfast foods and sweetened beverages.",

            midday:"Choose plenty of vegetables with dal, beans or lean protein and a controlled portion of whole grains. Water or unsweetened buttermilk can accompany the meal.",

            afternoon:"Choose nuts, seeds, roasted chana, fruit paired with nuts or unsweetened yogurt rather than biscuits, sweets or sugary drinks.",

            beforeLeaving:"If hungry, choose a small protein-and-fibre-rich snack such as sprouts, paneer, roasted makhana or mixed nuts.",

            advisory:"Educational guidance only. If you have prediabetes, follow personalised dietary guidance from your healthcare professional or registered dietitian."

        },

        type_1_diabetes:{

            image:"https://cdn.shopify.com/s/files/1/0588/5250/7777/files/food_diabetics.webp?v=1786083640",

            intro:"Regular meals, appropriate carbohydrate planning and your prescribed insulin routine can help support steadier glucose and energy through the workday.",

            morning:"Choose a balanced breakfast containing protein, whole grains and healthy fats while following your prescribed carbohydrate and insulin plan.",

            midday:"Choose vegetables, lean protein and an appropriate portion of whole grains according to your meal plan. Stay hydrated with water or unsweetened beverages.",

            afternoon:"Have a planned snack if required rather than relying on sugary foods for energy. Always keep your recommended fast-acting glucose source available for hypoglycaemia.",

            beforeLeaving:"If there will be a long interval before dinner, choose an appropriate snack consistent with your carbohydrate and insulin plan.",

            advisory:"Educational guidance only. Meal timing, carbohydrate intake and insulin requirements are individual. Follow the plan provided by your diabetes healthcare team."

        },

        type_2_diabetes:{

        image:"https://cdn.shopify.com/s/files/1/0588/5250/7777/files/food_diabetics.webp?v=1786083640",

        intro:"Balanced meals with protein, fibre and regular hydration can help support steady energy while reducing sharp blood glucose fluctuations during the workday.",

        morning:"Choose a protein-rich breakfast such as eggs, paneer, sprouts or unsweetened yogurt with whole grains, nuts or seeds. Prefer unsweetened tea, coffee or water.",

        midday:"Choose vegetables, dal or lean protein, whole grains in controlled portions, and curd or buttermilk. Avoid sugary drinks and very heavy meals.",

        afternoon:"Choose nuts, roasted chana, seeds, sprouts or a low-GI fruit paired with protein. Stay hydrated with water or unsweetened herbal tea.",

        beforeLeaving:"If dinner will be delayed, choose a light protein-rich snack such as paneer, boiled eggs, sprouts, roasted makhana or mixed nuts.",

        advisory:"Educational guidance only. Individual dietary needs may vary depending on medications, blood glucose control and other health conditions."

    },

        gestational_diabetes:{

        image:"https://cdn.shopify.com/s/files/1/0588/5250/7777/files/food_gestational_diabetics.webp?v=1786083640",

        intro:"Regular balanced meals and planned snacks can help support healthy blood glucose and steady energy during pregnancy.",

        morning:"Choose a protein-rich breakfast such as eggs, paneer, sprouts or unsweetened yogurt with whole grains and water or milk, according to your prescribed meal plan.",

        midday:"Choose vegetables, dal or lean protein, controlled portions of whole grains, and curd or buttermilk. Avoid sugary beverages.",

        afternoon:"Choose a light snack such as nuts, seeds, roasted chana, sprouts or unsweetened yogurt to help maintain energy between meals.",

        beforeLeaving:"If there is a long gap before dinner, choose a light protein-rich snack and continue drinking water regularly.",

        advisory:"Educational guidance only. If you have gestational diabetes, follow the dietary and glucose-monitoring advice provided by your obstetrician, diabetologist or registered dietitian."

        },

        previous_gestational_diabetes:{

        image:"https://cdn.shopify.com/s/files/1/0588/5250/7777/files/food_previous_gestational_diabetics.webp?v=1786083640",

        intro:"Balanced meals and regular eating habits can support steady energy and long-term metabolic wellbeing after a previous pregnancy affected by gestational diabetes.",

        morning:"Start with a balanced breakfast containing protein, whole grains, nuts or seeds and an unsweetened beverage.",

        midday:"Choose vegetables, lean protein, whole grains and curd or buttermilk while limiting refined carbohydrates and sugary drinks.",

        afternoon:"Choose fruit paired with nuts, roasted chana, seeds, sprouts or yogurt instead of highly processed snacks.",

        beforeLeaving:"If needed, choose a light snack such as paneer, sprouts, roasted makhana or mixed nuts to help maintain energy until dinner.",

        advisory:"Educational guidance only. A history of gestational diabetes is associated with a higher future risk of Type 2 diabetes, so regular health check-ups and healthy lifestyle habits remain important."

        }

    },

    better_focus:{

            not_sure:{

                image:"https://cdn.shopify.com/s/files/1/0588/5250/7777/files/healthy_meal.webp?v=1786090026",

                intro:"Choose balanced meals, protein-rich foods and regular hydration to help maintain steady energy and concentration through the workday.",

                morning:"Start with a protein-rich breakfast such as eggs, Greek yogurt, paneer, sprouts or oats with nuts, together with whole fruit and unsweetened tea or coffee.",

                midday:"Choose a balanced lunch with whole grains, plenty of vegetables, lean protein such as dal, beans, fish, chicken, tofu or paneer, and curd.",

                afternoon:"Choose a light snack such as nuts, seeds, roasted chana, fruit paired with nuts, or unsweetened buttermilk. Stay hydrated with water or herbal tea.",

                beforeLeaving:"Before leaving work, choose a light protein-rich snack such as roasted chickpeas, boiled eggs, sprouts, yogurt or a small handful of nuts to help maintain focus until dinner.",

                advisory:"General educational guidance only. Persistent difficulty with concentration or unexplained fatigue may have many causes and should be discussed with a qualified healthcare professional."

            },

            prediabetes:{

                image:"https://cdn.shopify.com/s/files/1/0588/5250/7777/files/food_prediabetics.webp?v=1786083641",

                intro:"Balanced meals with protein, fibre and steady hydration may help support concentration while avoiding sharp changes in blood glucose.",

                morning:"Choose Greek yogurt or unsweetened curd with nuts and seeds, or vegetable oats or cheela with unsweetened green tea or coffee.",

                midday:"Choose a balanced lunch with whole grains, dal or beans, lean protein, plenty of vegetables and salad. Avoid sugary drinks.",

                afternoon:"Choose almonds, walnuts, roasted chana or another protein-rich snack with buttermilk, lemon water or unsweetened herbal tea.",

                beforeLeaving:"Choose apple or guava with a handful of nuts, or sprouts or chickpea salad with herbal tea to help prevent energy dips and evening cravings.",

                advisory:"Educational guidance only. If you have prediabetes, follow personalised dietary advice from your healthcare professional or registered dietitian."

            },

            type_1_diabetes:{

                image:"https://cdn.shopify.com/s/files/1/0588/5250/7777/files/food_diabetics.webp?v=1786083640",

                intro:"Regular meals, appropriate carbohydrate planning and your prescribed insulin routine can help support steadier glucose, energy and concentration through the workday.",

                morning:"Choose Greek yogurt or paneer with nuts, boiled eggs or tofu, whole-grain toast, and unsweetened tea, coffee or water.",

                midday:"Choose a high-fibre lunch with whole grains, dal or beans, lean protein, plenty of vegetables, and water or unsweetened buttermilk.",

                afternoon:"Choose a small handful of nuts or seeds, roasted chana, or another low-sugar protein snack with green tea or herbal tea.",

                beforeLeaving:"Choose apple or pear with peanut butter, sprouts or hummus with vegetable sticks, together with water to help maintain hydration and steady energy.",

                advisory:"Educational guidance only. Meals and snacks should be matched to your individual insulin plan and blood glucose levels, following the advice of your diabetes healthcare team."

            },


            type_2_diabetes:{

                image:"https://cdn.shopify.com/s/files/1/0588/5250/7777/files/food_diabetics.webp?v=1786083640",

                intro:"Balanced meals with protein, fibre and healthy fats can help support steady blood glucose, energy and concentration through the workday.",

                morning:"Choose Greek yogurt or unsweetened curd with nuts and seeds, eggs or paneer, together with whole grains and unsweetened tea or coffee.",

                midday:"Choose a balanced lunch with whole grains in controlled portions, dal or beans, lean protein, plenty of vegetables and salad. Avoid sugary beverages.",

                afternoon:"Choose almonds, walnuts, roasted chana, seeds or another protein-rich snack with buttermilk, water or unsweetened herbal tea.",

                beforeLeaving:"Choose apple or guava with nuts, sprouts, paneer or chickpea salad to help maintain steady energy until dinner.",

                advisory:"Educational guidance only. Individual dietary needs may vary depending on medications, blood glucose control and other health conditions."

            },

            gestational_diabetes:{

                image:"https://cdn.shopify.com/s/files/1/0588/5250/7777/files/food_gestational_diabetics.webp?v=1786083640",

                intro:"Regular balanced meals and planned snacks can help support healthy blood glucose, steady energy and concentration during pregnancy.",

                morning:"Choose a protein-rich breakfast such as eggs, paneer, sprouts or unsweetened yogurt with whole grains, nuts or seeds, according to your prescribed meal plan.",

                midday:"Choose vegetables, dal or lean protein, controlled portions of whole grains and curd or buttermilk. Avoid sugary beverages.",

                afternoon:"Choose nuts, seeds, roasted chana, sprouts or unsweetened yogurt as a light snack and continue drinking water regularly.",

                beforeLeaving:"If dinner will be delayed, choose a light protein-rich snack such as paneer, sprouts, roasted makhana or a small handful of nuts.",

                advisory:"Educational guidance only. If you have gestational diabetes, follow the dietary and glucose-monitoring advice provided by your obstetrician, diabetologist or registered dietitian."

            },

            previous_gestational_diabetes:{

                image:"https://cdn.shopify.com/s/files/1/0588/5250/7777/files/food_previous_gestational_diabetics.webp?v=1786083640",

                intro:"Balanced meals, protein-rich foods and regular hydration can support concentration, steady energy and long-term metabolic wellbeing.",

                morning:"Start with a balanced breakfast such as eggs, paneer, sprouts or unsweetened yogurt with whole grains, nuts or seeds and an unsweetened beverage.",

                midday:"Choose vegetables, lean protein, dal or beans, whole grains and curd or buttermilk while limiting refined carbohydrates and sugary drinks.",

                afternoon:"Choose fruit paired with nuts, roasted chana, seeds, sprouts or yogurt instead of highly processed or sugary snacks.",

                beforeLeaving:"Choose a light snack such as paneer, sprouts, roasted makhana, chickpea salad or mixed nuts if dinner will be delayed.",

                advisory:"Educational guidance only. A history of gestational diabetes is associated with a higher future risk of Type 2 diabetes, so regular health check-ups and healthy lifestyle habits remain important."

            }


    },

        healthier_living:{

            not_sure:{

                image:"https://cdn.shopify.com/s/files/1/0588/5250/7777/files/healthy_meal.webp?v=1786090026",

                intro:"Build healthier everyday eating habits with balanced meals, nourishing snacks and regular hydration throughout your workday.",

                morning:"Start with a balanced breakfast containing protein such as eggs, paneer, sprouts or unsweetened yogurt, together with whole grains, nuts or seeds and an unsweetened beverage.",

                midday:"Choose a balanced lunch with plenty of vegetables, whole grains, dal, beans or another lean protein, and curd or buttermilk. Prefer water over sugary beverages.",

                afternoon:"Choose a nourishing snack such as fruit with nuts, roasted chana, seeds, sprouts or yogurt. Keep drinking water regularly through the afternoon.",

                beforeLeaving:"If dinner is still some time away, choose a light snack such as sprouts, paneer, roasted makhana, boiled eggs or mixed nuts rather than highly processed foods.",

                advisory:"General educational guidance only. Individual nutritional needs vary depending on health status, medications and medical history. Consult a qualified healthcare professional or registered dietitian for personalised advice."

            },

            prediabetes:{

                image:"https://cdn.shopify.com/s/files/1/0588/5250/7777/files/food_prediabetics.webp?v=1786083641",

                intro:"Choose balanced, fibre-rich meals and regular healthy snacks to support long-term metabolic health and steadier blood glucose.",

                morning:"Choose eggs, paneer, sprouts or unsweetened yogurt with whole grains, nuts or seeds. Avoid sugary breakfast foods and sweetened beverages.",

                midday:"Choose plenty of vegetables with dal, beans or lean protein and a controlled portion of whole grains. Add salad and choose water or unsweetened buttermilk.",

                afternoon:"Choose nuts, seeds, roasted chana, sprouts, fruit paired with nuts or unsweetened yogurt instead of biscuits, sweets or sugary drinks.",

                beforeLeaving:"If hungry, choose a small protein-and-fibre-rich snack such as paneer, sprouts, roasted makhana or mixed nuts to help avoid overeating later.",

                advisory:"Educational guidance only. If you have prediabetes, follow personalised dietary guidance from your healthcare professional or registered dietitian."

            },

            type_1_diabetes:{

                image:"https://cdn.shopify.com/s/files/1/0588/5250/7777/files/food_diabetics.webp?v=1786083640",

                intro:"Balanced nutrition, regular eating patterns and appropriate carbohydrate planning can support everyday wellbeing while complementing your prescribed diabetes management plan.",

                morning:"Choose a balanced breakfast containing protein, whole grains and healthy fats while following your prescribed carbohydrate and insulin plan.",

                midday:"Choose vegetables, lean protein and an appropriate portion of whole grains according to your meal plan. Stay hydrated with water or unsweetened beverages.",

                afternoon:"Choose a planned snack if required, such as nuts, roasted chana or yogurt. Always keep your recommended fast-acting glucose source available for hypoglycaemia.",

                beforeLeaving:"If there will be a long interval before dinner, choose an appropriate snack consistent with your carbohydrate and insulin plan.",

                advisory:"Educational guidance only. Meal timing, carbohydrate intake and insulin requirements are individual. Follow the plan provided by your diabetes healthcare team."

            },

            type_2_diabetes:{

                image:"https://cdn.shopify.com/s/files/1/0588/5250/7777/files/food_diabetics.webp?v=1786083640",

                intro:"Balanced meals with protein, fibre and healthy fats can support steadier blood glucose and healthier everyday eating habits.",

                morning:"Choose a protein-rich breakfast such as eggs, paneer, sprouts or unsweetened yogurt with whole grains, nuts or seeds. Prefer unsweetened tea, coffee or water.",

                midday:"Choose plenty of vegetables, dal or lean protein, whole grains in controlled portions, and curd or buttermilk. Avoid sugary drinks and highly refined foods.",

                afternoon:"Choose nuts, roasted chana, seeds, sprouts or a low-GI fruit paired with protein. Stay hydrated with water or unsweetened herbal tea.",

                beforeLeaving:"If dinner will be delayed, choose a light protein-rich snack such as paneer, boiled eggs, sprouts, roasted makhana or mixed nuts.",

                advisory:"Educational guidance only. Individual dietary needs may vary depending on medications, blood glucose control and other health conditions."

            },

            gestational_diabetes:{

                image:"https://cdn.shopify.com/s/files/1/0588/5250/7777/files/food_gestational_diabetics.webp?v=1786083640",

                intro:"Balanced meals and planned snacks can support healthy blood glucose and overall nutrition during pregnancy.",

                morning:"Choose a protein-rich breakfast such as eggs, paneer, sprouts or unsweetened yogurt with whole grains and water or milk, according to your prescribed meal plan.",

                midday:"Choose vegetables, dal or lean protein, controlled portions of whole grains, and curd or buttermilk. Avoid sugary beverages.",

                afternoon:"Choose a healthy snack such as nuts, seeds, roasted chana, sprouts or unsweetened yogurt and continue drinking water regularly.",

                beforeLeaving:"If there is a long gap before dinner, choose a light protein-rich snack such as paneer, sprouts, roasted makhana or a small handful of nuts.",

                advisory:"Educational guidance only. If you have gestational diabetes, follow the dietary and glucose-monitoring advice provided by your obstetrician, diabetologist or registered dietitian."

            },

            previous_gestational_diabetes:{

                image:"https://cdn.shopify.com/s/files/1/0588/5250/7777/files/food_previous_gestational_diabetics.webp?v=1786083640",

                intro:"Healthy eating habits can support long-term metabolic wellbeing after a pregnancy affected by gestational diabetes.",

                morning:"Start with a balanced breakfast containing protein, whole grains, nuts or seeds and an unsweetened beverage.",

                midday:"Choose vegetables, lean protein, dal or beans, whole grains and curd or buttermilk while limiting refined carbohydrates and sugary drinks.",

                afternoon:"Choose fruit paired with nuts, roasted chana, seeds, sprouts or yogurt instead of highly processed snacks.",

                beforeLeaving:"If needed, choose a light snack such as paneer, sprouts, roasted makhana or mixed nuts to help maintain steady energy until dinner.",

                advisory:"Educational guidance only. A history of gestational diabetes is associated with a higher future risk of Type 2 diabetes, so regular health check-ups and healthy lifestyle habits remain important."

            }


        }

        

};